import { useEffect } from "react";
import { formatFileSize } from "utils/common";
import Icon from "components/shared/Icon";
import InlineErrors from "./InlineErrors";

const FileItem = (props) => {
	const {
		filename,
		parentClass,
		size,
		errors = [],
		setHasError,
		removeFile,
		removeText,
		inlineErrors,
		index,
		setFileRemoved,
	} = props;

	const mainClass = `${parentClass}__item`;

	const idInputFile = document
		.querySelector("input[type=file]")
		?.getAttribute("id");
	const inputName = `${idInputFile}${index}.`;
	const hasInlineErrors = !!Object.keys(inlineErrors[inputName] || {}).length;

	useEffect(() => {
		setHasError && setHasError(hasInlineErrors);
	}, [errors, setHasError, hasInlineErrors]);

	const handleRemoveEvent = () => {
		removeFile && removeFile(inputName);
		setFileRemoved && setFileRemoved(true);
	};

	return (
		<div className={mainClass}>
			{hasInlineErrors ? (
				<>
					<div className={`${mainClass}__header`}>
						<div className={`${mainClass}__header__title`}>
							<Icon
								icon="icon_close-reversed"
								className={`${mainClass}__header__title__icon`}
							/>
							<label className={`${mainClass}__header__title__filename`}>
								{filename} ({formatFileSize(size)})
								<span
									className={`${mainClass}__header__title__filename_text`}
									onClick={() => {
										handleRemoveEvent();
									}}
								>
									{removeText}
								</span>
							</label>
						</div>

						<div className={`${mainClass}__header__info`}>
							<div
								className={`${mainClass}__header__info__error`}
								onClick={() => {
									handleRemoveEvent();
								}}
							>
								{inlineErrors && hasInlineErrors && (
									<InlineErrors
										validate={inputName}
										errorMessages={inlineErrors}
									/>
								)}
							</div>
						</div>
					</div>
				</>
			) : (
				<div className={`${mainClass}__header`}>
					<div className={`${mainClass}__header__title`}>
						{
							<Icon
								icon="checkmark"
								className={`${mainClass}__header__title__icon--done`}
							/>
						}
						<label className={`${mainClass}__header__title__filename`}>
							{filename} ({formatFileSize(size)})
							{
								<span
									onClick={() => {
										handleRemoveEvent();
									}}
									className={`${mainClass}__header__title__filename__text`}
								>
									{removeText}
								</span>
							}
						</label>
					</div>
				</div>
			)}
		</div>
	);
};
export default FileItem;
